<template>
    <div class="nav-container">
        <div id="nav">
            <div class="nav-left">
                <a href="/">
                    <img class="nav-logo" :src="settings.logoUrl">
                </a>
            </div>
            <div class="nav-mobile-close" v-on:click="toggleMenuLinks()" v-show="this.isActive">
                <span class="icon"><img src="/Assets/img/cancel.svg" /></span>
            </div>
            <div class="nav-links" v-bind:class="{ 'active': this.isActive }" v-if="!isSimpleView">

                <a href="/"><span v-on:click="toggleMenuLinks(false)">Deals</span></a>
                <router-link v-if="settings.showBlog" to="/blog"><span v-on:click="toggleMenuLinks(false)">{{settings.blogTitle}}</span></router-link>
                <router-link v-if="settings.showBlog" to="/gift-ideas"><span v-on:click="toggleMenuLinks(false)">Gift Ideas</span></router-link>
                <router-link to="/about"><span v-on:click="toggleMenuLinks(false)">About</span></router-link>
                <router-link to="/contact"><span v-on:click="toggleMenuLinks(false)">Contact</span></router-link>


            </div>
            <div class="nav-right" v-on:click="toggleMenuLinks()" v-if="!isSimpleView">
                <span class="icon"><img src="/Assets/img/menu.svg" /></span>
            </div>
        </div>
        <VideoContainer2 v-if="$route.name == 'home' && settings.siteName == 'mommydeals'" />
        <div v-else-if="!isSimpleView && $route.name !== 'giveaway' && $route.name !== 'startShopping' && $route.name !== 'giftideas' && $route.name !== 'giftlist' && $route.name !== 'giftlist2' && settings.topBannerAnimationSrc && settings.socialLinks.whatsapp && $route.name !== 'dealnumber' && $route.name !== 'deal' && $route.name !== 'deal2'">
            <a :href="settings.socialLinks.whatsapp" target="_blank" @click="joinWhatsapp()">
                <div class="join_whatsapp_top">
                    <div class="cover"></div>
                    <div>
                        <button class="button-cta"><span class="play-icon"><img src="/assets/img/logo-whatsapp.png" /></span>Join MommyDeals</button>
                    </div>
                </div>
            </a>
        </div>

    </div>
</template>

<script>
    import settings from '@/settings'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'
    import VideoContainer2 from '@/components/VideoContainer2'
    export default {
        data() {
            return {
                isActive: false,
                isSimpleView: false
            }
        },
        created() {
            if (this.$route.query.direct)
                this.isSimpleView = true;
            else
                this.isSimpleView = false;
        },
        computed: {
            settings: function () { return settings; }
        },
        methods: {
            toggleMenuLinks(toggleValue) {
                this.isActive = (toggleValue || !this.isActive);
            },
            joinWhatsapp() {
                ga.event('click', { 'event_category': 'whatsapp', 'event_label': 'whatsapp', 'transport_type': 'beacon' });
                clicky.goal("JoinWhatsApp2")
            }
        },
        components: {
            VideoContainer2
        }
    }
</script>